module.exports = __webpack_public_path__ + "static/case-study-lady-39361465d8e72392abf8f88a46c77dcc.jpg";